import { FC } from 'react'
import { SectionCardSliderProps } from '@portfolio/models'
import {
  Media,
  MediaWithBackground,
  SectionWrapper,
  Slider,
} from '@portfolio/components'
import { styled } from '@portfolio/styles'

const SlideWrap = styled('div', {
  gridRow: 1,
})

const Text = styled('p', {
  projectFont: 'body04',
  color: '$black_06',
  width: '85%',
  gridRow: 2,
})

const StyledSectionWrapper = styled(SectionWrapper, {
  display: 'grid',
  rowGap: '$20',
})

export const SectionCardSlider: FC<SectionCardSliderProps> = ({
  slides,
  priority,
}) => {
  return (
    <StyledSectionWrapper type="RICH_TEXT_LG">
      <Slider>
        {slides?.map(
          (slide, index) =>
            slide?.media?.mediaPayload && (
              <SlideWrap
                key={`${slide?.media?.alt}-${slide._type}-${index}`}
                style={{ gridColumn: index + 1 }}
              >
                {slide._type === 'simpleMedia' ? (
                  <div>
                    <Media
                      {...slide.media}
                      priority={priority && index < 3}
                      sizes="(min-width: 1000px) 486px, 290px"
                    />
                  </div>
                ) : (
                  <MediaWithBackground
                    media={slide.media}
                    priority={priority && index < 3}
                    mediaBorder={slide.mediaBorder}
                    color={slide.color}
                    sizes="(min-width: 1000px) 486px, 290px"
                    appearance="slider"
                  />
                )}
              </SlideWrap>
            ),
        )}
        {slides?.map(
          (slide, index) =>
            slide?.media?.mediaPayload &&
            slide.text && (
              <Text style={{ gridColumn: index + 1 }} key={`${index}-text`}>
                ↑ {slide.text}
              </Text>
            ),
        )}
      </Slider>
    </StyledSectionWrapper>
  )
}
